import { useDateLimits } from '../../../hooks'
import { Container } from '../Container'
import { DateTimeProviderProps } from '../DateTime'

function UseDateLimitsExample() {
  const limits = useDateLimits()

  return (
    <Container label='const limits = useDateLimits()'>
      <pre>{JSON.stringify(limits, null, 2)}</pre>
    </Container>
  )
}

export function UseDateLimits() {
  return (
    <DateTimeProviderProps>
      <UseDateLimitsExample />
    </DateTimeProviderProps>
  )
}
